import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    const res = await login(form.email, form.password);
    setBusy(false);
    if (res.ok) nav("/admin", { replace: true });
    else setError(res.error || "Login failed");
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6 py-20" data-testid="page-admin-login">
      <div className="w-full max-w-md border border-rule bg-card p-10">
        <div className="flex items-center gap-3 mb-6">
          <Lock size={18} />
          <span className="specimen-label">Restricted · Admin Only</span>
        </div>
        <h1 className="font-serif text-4xl mb-2 leading-tight">Admin Login</h1>
        <p className="text-sm text-muted mb-8">Manage SeedKeepers resources.</p>

        <form onSubmit={onSubmit} className="space-y-6">
          <div>
            <label className="specimen-label">Email</label>
            <input
              required
              type="email"
              autoFocus
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="field-input"
              data-testid="login-email"
            />
          </div>
          <div>
            <label className="specimen-label">Password</label>
            <input
              required
              type="password"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              className="field-input"
              data-testid="login-password"
            />
          </div>
          {error && <p className="text-terracotta text-sm font-mono" data-testid="login-error">{error}</p>}
          <button
            type="submit"
            disabled={busy}
            className="w-full bg-eucalypt text-chalk px-7 py-4 font-mono text-[11px] tracking-[0.25em] uppercase hover:bg-eucalypt-dark transition-colors disabled:opacity-60"
            data-testid="login-submit"
          >
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>

        <Link to="/" className="link-mono text-eucalypt block mt-8 text-center" data-testid="login-back-home">
          ← Back to site
        </Link>
      </div>
    </div>
  );
}
